import { createActions } from 'reduxsauce';

const { Types: types, Creators: actions } = createActions({
    // add category
    requestSubmitCategory: ['id', 'data'],
    submitCategorySucceeded: ['data'],
    submitCategoryFailed: ['errors'],

    // clear state
    clearCategoryCreateState: null,
});

export default {
    // add category
    [types.REQUEST_SUBMIT_CATEGORY]: (state) => ({
        ...state,
        create: {
            ...state.create,
            submitting: true,
            errors: null,
        },
    }),
    [types.SUBMIT_CATEGORY_SUCCEEDED]: (state, { data }) => ({
        ...state,
        create: {
            ...state.create,
            submitting: false,
            categoryDetails: data,
            success: true,
        },
    }),
    [types.SUBMIT_CATEGORY_FAILED]: (state, { errors }) => ({
        ...state,
        create: {
            ...state.create,
            submitting: false,
            success: false,
            errors,
        },
    }),

    // clear state
    [types.CLEAR_CATEGORY_CREATE_STATE]: (state) => ({
        ...state,
        create: {
            ...state.create,
            categoryDetails: null,
            success: false,
            errors: null,
        },
    }),
};

export { types, actions };